import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  initialize() {
    this.form = this.element
    this.submitButton = this.form.querySelector("[type='submit']")

    // Run once to check if the button should be disabled by default
    this.updateDisableState()
  }

  updateDisableState() {
    const inputs = this.form.querySelectorAll("input, textarea")
    const allValid = Array.from(inputs).every(el => el.checkValidity())

    if (allValid) {
      this.submitButton.classList.remove("disabled")
      this.submitButton.disabled = false
    } else {
      this.submitButton.classList.add("disabled")
      this.submitButton.disabled = true
    }
  }
}
